import { isDevelopment } from '../dev';
import { _url as regularUrl } from './_url';

type MakeUrlType = (url: string, always?: boolean, _url?: string) => string;

const makeUrl: MakeUrlType = (url = '', always, _url = regularUrl): string => {
  const isFullUrl =
    !!url.match(/https?/g) &&
    !!url.match(
      /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g
    );
  if (isFullUrl) return url;
  const isAlwaysEnv = process.env.URL_ALWAYS;
  const urlWithPrefix = url.includes(_url) ? url : `${_url}${url}`;
  if (always || isAlwaysEnv) {
    return urlWithPrefix;
  }
  return isDevelopment ? urlWithPrefix : url;
};
function withUrl(url: string, always?: boolean): string;
function withUrl(always?: boolean): (url: string) => string;
/**
 *
 * @example
 * basic
 * withUrl('/api/wow') => '/api/wow'
 * withUrl('/api/wow', true) => 'https://rsttur.ru/api/wow'
 * @example
 * curry
 * withUrl()('/api/wow') => '/api/wow'
 * withUrl(true)('/api/wow') => 'https://rsttur.ru/api/wow'
 */
function withUrl(a?: string | boolean, b?: boolean) {
  if (typeof a === 'string') {
    return makeUrl(a, b);
  }
  return (c: string) => makeUrl(c, a);
}
function withRstUrl(a: string) {
  return makeUrl(a, true, 'https://rsttur.ru');
}
export { withUrl, withRstUrl };
